// Pure helpers pentru formularele de angajat/user din EmployeeDetails.vue: obiectul gol
// de formular + normalizări de câmpuri (date, numerice, text). Extrase pentru modularitate
// + testabilitate (fără refs/axios). Comportament identic cu definițiile inline originale.

export const createEmptyEmployeeForm = () => ({
  id: null,
  company_id: null,
  first_name: "",
  last_name: "",
  birth_date: "",
  hire_date: "",
  release_date: "",
  available_co_days: "",
  status: 1,
  phone: "",
  email: "",
  position: "",
  role: "",
  id_manager: null,
  department: "",
  salary: "",
  type_of_contract: "",
  address: "",
  cnp: "",
  gender: "",
  nationality: "",
  marital_status: "",
});

// Normalizează o dată pentru un <input type="date"> (YYYY-MM-DD), păstrând valoarea
// originală dacă nu poate fi parsată.
export const normalizeDateForInput = (value) => {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return new Date(parsed.getTime() - parsed.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
};

// Reprezentare string a unui câmp numeric pentru input (gol pentru null/undefined/"").
export const formatNumericField = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return String(value);
};

// Parsează un câmp numeric din payload: null pentru gol/invalid, altfel Number.
export const parseNumeric = (value) => {
  if (value === null || value === undefined) return null;
  const processed = typeof value === "string" ? value.trim() : value;
  if (processed === "") return null;
  const num = Number(processed);
  return Number.isNaN(num) ? null : num;
};

// Text obligatoriu: string trimuit (niciodată null).
export const sanitizeRequiredText = (value) => String(value || "").trim();

// Text opțional: null pentru gol, altfel string trimuit.
export const sanitizeText = (value) => {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  return trimmed === "" ? null : trimmed;
};
